﻿import * as React from "react";

export interface IMessagePopupProps {
    message?: string;
    timeout?: number;
    iteration: number;
}

export class MessagePopup extends React.Component<IMessagePopupProps> {
    private _popupRef: HTMLDivElement;

    private _timer: number;

    private readonly _onTimeout = (): void => {
        this._popupRef.className = `messagepopup-message hide`;
    };

    render(): React.ReactElement {
        // Clear any already existing timer.
        if (this._timer != null) {
            clearTimeout(this._timer);
        }

        // Set a new timer to hide the message.
        if (this.props.timeout && this.props.message) {
            this._timer = setTimeout(this._onTimeout, this.props.timeout);
        }
        // Render the message.
        if (this.props.message) {
            // Provide the iteration, this forces react to set the class back to being visible.
            const classname = `messagepopup-message ${this.props.iteration}`;

            return (
                <div className={`messagepopup`}>
                    <div
                        className={classname}
                        ref={(aa): HTMLDivElement => (this._popupRef = aa)}
                    >
                        {this.props.message}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}
